import React, { useState } from "react";
import { Button, Col, Form, Input, Modal, Table } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { SaveIcon } from "icons/Icons";

import "./RoamingItemListEdit.css";
import { NestedRow, RoamingItemListEditProps } from "domain/RoamingItems";

const RoamingItemListEdit: React.FC<RoamingItemListEditProps> = ({
  isModalOpen,
  setIsModalOpen,
  selectedRow,
}) => {
  const [form] = Form.useForm();
  const [isLoading, setLoading] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleOk = async () => {
    try {
      setIsSubmitted(true);
      const values = await form.validateFields();
      const payload = { ...values };
      console.log(payload);
      
    } catch (error) {
      console.error("Error submitting form:", error);
    } finally {
      setIsSubmitted(false);
    }
  };

  const handleCancel = () => {
    setIsModalOpen((prev) => ({ ...prev, editForm: false }));
  };

  const nestedTableColumns = [
    { title: "RFID", dataIndex: "RFID", key: "RFID" },
    { title: "Date Added", dataIndex: "DateAdded", key: "DateAdded" },
    { title: "No Cycles", dataIndex: "NoCycles", key: "NoCycles" },
  ];

  return (
    <Modal
      title="Edit Form"
      width="100%"
      centered
      visible={isModalOpen}
      bodyStyle={{ height: "76vh", overflow: "hidden" }}
      onOk={handleOk}
      onCancel={handleCancel}
      footer={[
        <Button
          key="save"
          type="primary"
          icon={<SaveIcon />}
          onClick={handleOk}
          loading={isLoading}
        >
          Save
        </Button>,
        <Button key="cancel" icon={<CloseOutlined />} onClick={handleCancel}>
          Cancel
        </Button>,
      ]}
    >
      <Form
        form={form}
        requiredMark={false}
        layout="vertical"
        style={{ display: "flex", gap: 8 }}
        initialValues={{
          price: selectedRow.Price,
          sell_price: selectedRow.SellPrice,
        }}
      >
        <Col span={3}>
          <Form.Item
            label="Price"
            name="price"
            rules={[{ required: true, message: "Price is required" }]}
          >
            <Input placeholder="Price" />
          </Form.Item>
        </Col>
        <Col span={3}>
          <Form.Item
            label="Sell Price"
            name="sell_price"
            rules={[{ required: true, message: "Sell Price is required" }]}
          >
            <Input placeholder="Sell Price" />
          </Form.Item>
        </Col>
      </Form>

      <Table<NestedRow>
        scroll={{ x: "max-content" }}
        className="redesign-table"
        dataSource={selectedRow?.nestedData || []}
        columns={nestedTableColumns}
        pagination={false}
        rowKey="RFID"
      />
    </Modal>
  );
};

export default RoamingItemListEdit;
